import * as React from 'react'

const SvgEngineeringIcon = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="10" fill="#FF692E" />
    <path
      d="M18 18L22.5 22.5M18 18H15L14 15L15 14L18 15V18ZM31.259 14.741L28.6314 17.3686C28.2354 17.7646 28.0373 17.9627 27.9632 18.191C27.8979 18.3918 27.8979 18.6082 27.9632 18.809C28.0373 19.0373 28.2354 19.2354 28.6314 19.6314L28.8686 19.8686C29.2646 20.2646 29.4627 20.4627 29.691 20.5368C29.8918 20.6021 30.1082 20.6021 30.309 20.5368C30.5373 20.4627 30.7354 20.2646 31.1314 19.8686L33.5893 17.4107C33.854 18.0549 34 18.7604 34 19.5C34 22.5376 31.5376 25 28.5 25C28.1338 25 27.7759 24.9642 27.4298 24.8959C26.9436 24.8001 26.7005 24.7521 26.5532 24.7668C26.3965 24.7824 26.3193 24.8059 26.1805 24.8802C26.0499 24.9501 25.919 25.081 25.657 25.343L18.5 32.5C17.6716 33.3284 16.3284 33.3284 15.5 32.5C14.6716 31.6716 14.6716 30.3284 15.5 29.5L22.657 22.343C22.919 22.081 23.0499 21.9501 23.1198 21.8195C23.1941 21.6807 23.2176 21.6035 23.2332 21.4468C23.2479 21.2995 23.1999 21.0564 23.1041 20.5702C23.0358 20.2241 23 19.8662 23 19.5C23 16.4624 25.4624 14 28.5 14C29.5055 14 30.448 14.2698 31.259 14.741ZM24.0001 26.9999L29.5 32.4999C30.3284 33.3283 31.6716 33.3283 32.5 32.4999C33.3284 31.6715 33.3284 30.3283 32.5 29.4999L27.9753 24.9753C27.655 24.945 27.3427 24.8872 27.0408 24.8043C26.6517 24.6975 26.2249 24.7751 25.9397 25.0603L24.0001 26.9999Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgEngineeringIcon
